import { useReCaptchaContext } from '../components/ReCaptchaProvider';

/**
 * Hook to execute reCAPTCHA and get a token for form submissions.
 * 
 * @example
 * const { executeRecaptcha } = useRecaptcha();
 * 
 * const handleSubmit = async (data) => {
 *   const token = await executeRecaptcha('register');
 *   await api.register({ ...data, recaptchaToken: token });
 * };
 */
export const useRecaptcha = () => {
  const { isLoaded, executeRecaptcha } = useReCaptchaContext();

  return {
    /**
     * Whether reCAPTCHA is loaded and ready to use.
     */
    isLoaded,

    /**
     * Execute reCAPTCHA with the specified action and return a token.
     * 
     * @param action - Action name (e.g., 'register', 'login')
     * @returns Promise resolving to the reCAPTCHA token
     * @throws Error if reCAPTCHA is not loaded or execution fails
     */
    executeRecaptcha,
  };
};
